import * as React from "react";
const MiniHaircutFemale3 = ({ color }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="468 75 200 300">
		<title>{"coiffure f 3"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect fill="none" width={1080} height={1920} />
		</g>
		<g id="coiffure_f" data-name="coiffure f">
			<path
				fill={color}
				stroke="black"
				strokeWidth="0.25"
				d="M434,421.85S411.72,341,454,295c14-15,16-69,15-86s12-81,53-92,64-4,64-4l1,7s26,3,39,22,21,52,30,101,13,46,22,71,14.52,84.06,7.26,105.53C671,413,612,387,603,369c0-3-2-49-2-49s34-20,35-62c5-1,14-12,14-28-1-11-3-17-6-19-3-.93-8-.07-8-.07L635,233s-17,0-17-26c-13-1-40-23-42-38-10,23-52,41-77,40,0,9-1,16-10,19,0-13-1-17-1-17s-8.1-1.93-11.05,1-8.23,20.14-2.59,32.05S483,257,488,258c0,5,2,39,35,62-1,22-2,46-2,49-1,2-7.24,11.49-26.95,23.05C472,405,434,421.85,434,421.85Z"
			/>
		</g>
	</svg>
);
export default MiniHaircutFemale3;
